import Vue from 'vue'
import { minimalSinister } from '@/transformers/sinister'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * @param slug sinister's slug
 *
 * Fetch sinisters or sinister
 * @return {Array}
 * @return {Object}
 */

export default (slug = '') => {
  return Vue.$http.get(`sinister/no-permission/${slug}/`)
    .then(({ data }) => minimalSinister.fetch(data))
}
